import { BrowserRouter, HashRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import "antd/dist/antd.css";

import Router from "./router";
import i18n from "./translation";
import React from "react";

const App = () => {
  console.log("process.env.PUBLIC_URL", process.env.PUBLIC_URL);
  if (process.env.PUBLIC_URL?.includes("DIC_Project_Web_UI")) {
    console.log("Github Pages");
    return (
      <HashRouter>
        <I18nextProvider i18n={i18n}>
          <Router />
        </I18nextProvider>
      </HashRouter>
    );
  }

  return (
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <Router />
      </I18nextProvider>
    </BrowserRouter>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
